import { Stack, Tooltip } from "@octopus-energy/coral/atoms"
import { IconCircleInformationOutlined } from "@octopus-energy/icons"
import { format } from "date-fns"
import { fr } from "date-fns/locale"
import { useTranslations } from "next-intl"
import { DATE_FORMAT_PATTERN } from "@/constants/dates"
import { type OffPeakValue } from "../../types/offPeakValues"

function formatDayMonth(day: number, month: number) {
    return format(new Date(2026, month - 1, day), DATE_FORMAT_PATTERN.DAY_MONTH, { locale: fr })
}

type OffPeakSeasonTooltipProps = {
    offPeakValue: OffPeakValue
    size?: number
}

export function OffPeakSeasonTooltip({ offPeakValue, size = 20 }: OffPeakSeasonTooltipProps) {
    const t = useTranslations("OffPeakSeasonTooltip")

    return (
        <Stack
            display="inline-flex"
            alignItems="center"
        >
            <Tooltip
                title={t("seasonalPeriod", {
                    startDate: formatDayMonth(
                        offPeakValue.season.startDay,
                        offPeakValue.season.startMonth
                    ),
                    endDate: formatDayMonth(
                        offPeakValue.season.endDay,
                        offPeakValue.season.endMonth
                    ),
                })}
            >
                <IconCircleInformationOutlined size={size} />
            </Tooltip>
        </Stack>
    )
}

OffPeakSeasonTooltip.messages = ["OffPeakSeasonTooltip"] as const
